import { render, staticRenderFns } from "./task-center.vue?vue&type=template&id=228aaabf&scoped=true&"
import script from "./task-center.vue?vue&type=script&lang=js&"
export * from "./task-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228aaabf",
  null
  
)

export default component.exports